import { ProjectType } from '../../common/constants'

export const JOB_KANBAN_FEATURE = 'estimates-jobs-kanban'

export const JobListViews = { List: 'list', Kanban: 'kanban' } as const
export type JobListView = typeof JobListViews[keyof typeof JobListViews]

type PageIdentity = {
  jobType?: ProjectType
  deleted?: boolean
}

export const jobListSettingKey = ({ jobType, deleted }: PageIdentity, setting: string) =>
  `job-list/${jobType ?? 'estimates'}/${setting}${deleted ? '/deleted' : ''}`

export const jobListViewKey = (page: PageIdentity) => jobListSettingKey(page, 'view')

export const isKanban = (view: JobListView) => view === JobListViews.Kanban

export const CardDensities = { Detailed: 'detailed', Condensed: 'condensed' } as const
export type CardDensity = typeof CardDensities[keyof typeof CardDensities]

export const cardDensityKey = (page: PageIdentity) => jobListSettingKey(page, 'card-density')

export const isCondensed = (density: CardDensity) => density === CardDensities.Condensed
